import { CART_STATUSES } from '@gozoki/api-types'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { CustomerPage } from '~/components/routes/users/customer/customer-page'
import { USERS_SCREEN_PERMISSIONS } from '~/components/routes/users/screens'
import { withRoutePermissions } from '~/utils/rbac'

/** Borne haute de `pageSize` côté backend (`listCustomerCartsSchema` : `range([1, 100])`). */
const MAX_CARTS_PAGE_SIZE = 100

/** Pagination et filtre de l'historique d'achats, portés par l'URL (lien partageable). */
const searchSchema = z.object({
  page: z.number().int().positive().optional(),
  pageSize: z.number().int().min(1).max(MAX_CARTS_PAGE_SIZE).optional(),
  status: z.enum(CART_STATUSES).optional(),
})

/**
 * Fiche client (kanban #870, lot 3). Même garde que l'ancienne fiche `/users/edit/$userId`, qui
 * redirige ici : la lecture suffit à ouvrir la page, chaque action porte son propre droit.
 */
export const Route = createFileRoute('/_authenticated/users/$userId')({
  staticData: {
    permission: USERS_SCREEN_PERMISSIONS.app,
  },
  params: {
    parse: z.object({ userId: z.coerce.number().int().positive() }).parse,
  },
  validateSearch: searchSchema,
  component: CustomerRoute,
})
withRoutePermissions(Route)

function CustomerRoute() {
  const { userId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <CustomerPage
      userId={userId}
      search={search}
      onSearchChange={(updates) =>
        navigate({ search: (previous) => ({ ...previous, ...updates }), replace: true })
      }
    />
  )
}
